// src/modules/Files/utils/get-file-upload-url.ts
var getFileUploadUrl = async (file, { requireAuth = true } = {}) => {
	try {
		if (!file.name) throw new Error("no file.name");
		const rpcService = window.rpcService;
		const { data: { accessUrl, uploadMethod, uploadUrl } } = await (requireAuth ? rpcService.Files.GetFileUploadUrl.v1 : rpcService.External.GetFileUploadUrl.v1).call({
			contentType: file.type,
			fileName: file.name,
			metadata: {}
		});
		return {
			accessUrl,
			uploadMethod,
			uploadUrl
		};
	} catch (err) {
		console.error("getFileUploadUrl() errored on rpc.Files.GetFileUploadUrl.v1.call()", file, err);
		throw err;
	}
};
export { getFileUploadUrl };

//# sourceMappingURL=get-file-upload-url.js.map